module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 offset-lg-2 col-lg-8"
  }, [_c('page-content', {
    attrs: {
      "orders": _vm.orders
    },
    on: {
      "toggleShowDetail": _vm.toggleShowDetail
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a3164a7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/subPages/MyPage/Order/History.vue
// module id = 717
// module chunks = 0